import React, { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';

const DisclaimerScreen: React.FC = () => {
    const [accepted, setAccepted] = useState(true);

    useEffect(() => {
        const isAccepted = localStorage.getItem('acme_disclaimer_accepted');
        if (!isAccepted) {
            setAccepted(false);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('acme_disclaimer_accepted', 'true');
        setAccepted(true);
    };

    const handleReject = () => {
        window.location.href = 'https://www.google.com/search?q=filhotes+de+gatos+fofos&tbm=isch';
    };

    if (accepted) return null;

    return (
        <div className="fixed inset-0 z-[9999] bg-zinc-950 flex flex-col items-center justify-center p-6 text-zinc-300 font-mono overflow-y-auto">
            <div className="max-w-2xl w-full bg-black/80 border border-zinc-800 p-8 flex flex-col items-center text-center shadow-[0_0_50px_rgba(0,0,0,0.9)] relative backdrop-blur-md">
                {/* Decorative borders */}
                <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-red-900/50"></div>
                <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-red-900/50"></div>
                <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-red-900/50"></div>
                <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-red-900/50"></div>

                <AlertTriangle className="w-16 h-16 text-red-800 mb-6 drop-shadow-[0_0_15px_rgba(153,27,27,0.8)] animate-pulse" />

                <h1 className="text-3xl md:text-4xl font-black text-red-800 tracking-widest uppercase mb-8 border-b border-red-900/30 pb-4 w-full">AVISO CONFIDENCIAL</h1>

                <div className="space-y-6 text-sm md:text-base leading-relaxed text-zinc-400 font-serif mb-10 w-full">
                    <p className="bg-zinc-900/50 p-4 border border-zinc-800 rounded">
                        Todos os arquivos, nomes e eventos retratados neste sistema são estritamente fictícios. Qualquer semelhança com a realidade é mera coincidência. A <strong className="text-zinc-200">Agência ACME</strong> não cria casos baseados em tragédias reais, em absoluto respeito às vítimas e seus familiares.
                    </p>

                    <p className="border-l-4 border-red-800 pl-4 py-2 italic font-bold">
                        Atenção: Os arquivos a seguir contêm descrições de crimes, violência e temas sensíveis. Acesso recomendado apenas para maiores de 16 anos.
                    </p>
                </div>

                <div className="flex flex-col md:flex-row gap-4 w-full">
                    <button
                        onClick={handleAccept}
                        className="flex-1 bg-red-900 hover:bg-red-800 text-white font-bold py-4 uppercase tracking-widest transition-colors border border-red-700 hover:shadow-[0_0_20px_rgba(185,28,28,0.4)]"
                    >
                        Compreendo. Abrir Arquivos (16+)
                    </button>

                    <button
                        onClick={handleReject}
                        className="flex-1 bg-transparent hover:bg-zinc-900 text-zinc-500 hover:text-zinc-300 font-bold py-4 uppercase tracking-wider transition-colors border border-zinc-800"
                    >
                        Sou sensível a isso. Me tire daqui!
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DisclaimerScreen;
